/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mvp_Sprint_Analytics_Title9Inputs */

const en_svc_mvp_sprint_analytics_title9 = /** @type {(inputs: Svc_Mvp_Sprint_Analytics_Title9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytics`)
};

const ar_svc_mvp_sprint_analytics_title9 = /** @type {(inputs: Svc_Mvp_Sprint_Analytics_Title9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التحليلات`)
};

const bn_svc_mvp_sprint_analytics_title9 = /** @type {(inputs: Svc_Mvp_Sprint_Analytics_Title9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যানালিটিক্স`)
};

const de_svc_mvp_sprint_analytics_title9 = /** @type {(inputs: Svc_Mvp_Sprint_Analytics_Title9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytics`)
};

const es_svc_mvp_sprint_analytics_title9 = /** @type {(inputs: Svc_Mvp_Sprint_Analytics_Title9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analítica`)
};

const fr_svc_mvp_sprint_analytics_title9 = /** @type {(inputs: Svc_Mvp_Sprint_Analytics_Title9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analytique`)
};

const pt_svc_mvp_sprint_analytics_title9 = /** @type {(inputs: Svc_Mvp_Sprint_Analytics_Title9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análise`)
};

const zh_svc_mvp_sprint_analytics_title9 = /** @type {(inputs: Svc_Mvp_Sprint_Analytics_Title9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数据分析`)
};

const tr_svc_mvp_sprint_analytics_title9 = /** @type {(inputs: Svc_Mvp_Sprint_Analytics_Title9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analitik`)
};

const ru_svc_mvp_sprint_analytics_title9 = /** @type {(inputs: Svc_Mvp_Sprint_Analytics_Title9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аналитика`)
};

const pl_svc_mvp_sprint_analytics_title9 = /** @type {(inputs: Svc_Mvp_Sprint_Analytics_Title9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analityka`)
};

/**
* | output |
* | --- |
* | "Analytics" |
*
* @param {Svc_Mvp_Sprint_Analytics_Title9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mvp_sprint_analytics_title9 = /** @type {((inputs?: Svc_Mvp_Sprint_Analytics_Title9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mvp_Sprint_Analytics_Title9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mvp_sprint_analytics_title9(inputs)
	if (locale === "bn") return bn_svc_mvp_sprint_analytics_title9(inputs)
	if (locale === "de") return de_svc_mvp_sprint_analytics_title9(inputs)
	if (locale === "es") return es_svc_mvp_sprint_analytics_title9(inputs)
	if (locale === "fr") return fr_svc_mvp_sprint_analytics_title9(inputs)
	if (locale === "pt") return pt_svc_mvp_sprint_analytics_title9(inputs)
	if (locale === "zh") return zh_svc_mvp_sprint_analytics_title9(inputs)
	if (locale === "tr") return tr_svc_mvp_sprint_analytics_title9(inputs)
	if (locale === "ru") return ru_svc_mvp_sprint_analytics_title9(inputs)
	if (locale === "pl") return pl_svc_mvp_sprint_analytics_title9(inputs)
	return en_svc_mvp_sprint_analytics_title9(inputs)
});
export { svc_mvp_sprint_analytics_title9 as "svc_mvp-sprint_ANALYTICS_title" }